module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1i5wl"))).then(() => parcelRequire('ikE14'));